//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CHADS2",
  data() {
    return {
      defaultJson: {
        "Prior Stroke or TIA": "脑卒中或 TIA 病史",
        "Chronic Heart Failure": "慢性心衰",
        Hypertension: "高血压",
        "Age ≥ 75 years": "年龄 ≥ 75 岁",
        "Diabetes Mellitus": "糖尿病",
        "Stroke Rate": "脑卒中发病率",
      },
      form: {
        hf: "0",
        hta: "0",
        age: "0",
        diab: "0",
        prior: "0",
      },
      scoreObj: {
        0: 1.9,
        1: 2.8,
        2: 4,
        3: 5.9,
        4: 8.5,
        5: 12.5,
        6: 18.2,
      },
      /* scoreList:[
          {0: 0},
          {1: 1.3},
          {2: 2.2},
          {3: 3.2},
          {4: 4},
          {5: 6.7},
          {6: 9.8},
          {7: 9.6},
          {8: 6.7},
          {9: 15.2}
        ], */
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // hf + hta + age + diab + (prior ? 2 : 0)
        let result = form.hf + form.hta + form.age + form.diab + form.prior * 2;

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/CHADS2.vue